"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = require("prop-types");
const styles_1 = require("./styles");
const MobileHeaderLayout_1 = __importDefault(require("./MobileHeaderLayout"));
const messages_1 = __importDefault(require("../../lib/messages"));
const MobileHeader = (0, react_1.forwardRef)(({ activeStep, searchMatchEnabled, backToSearchPageURL, onGoBack, config, featureFlags, stepsConfiguration, track, isApptSummary }, ref) => {
    const getProgressBarValue = () => ((activeStep + 1) * 100) / ((stepsConfiguration === null || stepsConfiguration === void 0 ? void 0 : stepsConfiguration.length) - 1);
    if (!stepsConfiguration) {
        return (react_1.default.createElement(styles_1.Container, { "data-testid": "MobileHeaderSkeleton", ref: ref },
            react_1.default.createElement(styles_1.MobileHeaderSkeleton, null)));
    }
    return (react_1.default.createElement(styles_1.Container, { "data-testid": "MobileHeader", ref: ref },
        react_1.default.createElement(MobileHeaderLayout_1.default, { onGoBack: () => onGoBack(stepsConfiguration[activeStep - 1].stateKey), headerText: Object.assign({}, messages_1.default[stepsConfiguration[activeStep].stepperLabelId]), config: config, featureFlags: featureFlags, searchMatchEnabled: searchMatchEnabled, backToSearchPageURL: backToSearchPageURL, isBackButtonVisible: activeStep !== 0 && isApptSummary === false, track: track }),
        !isApptSummary && (react_1.default.createElement(styles_1.DeterminateLinearProgress, { variant: "determinate", value: getProgressBarValue() }))));
});
MobileHeader.displayName = 'MobileHeader';
MobileHeader.propTypes = {
    // active step to highlight
    activeStep: prop_types_1.string.isRequired,
    searchMatchEnabled: prop_types_1.bool.isRequired,
    backToSearchPageURL: prop_types_1.string,
    // callback for 'back' click
    onGoBack: prop_types_1.func.isRequired,
    config: prop_types_1.object.isRequired,
    // steps configuration object. see constants/steps
    stepsConfiguration: prop_types_1.object,
    track: prop_types_1.func.isRequired,
    isApptSummary: prop_types_1.bool.isRequired,
    featureFlags: (0, prop_types_1.shape)({
        dbw_suggest_alt_providers_for_step_1: prop_types_1.bool,
        dbw_suggest_alt_providers_for_step_2: prop_types_1.bool,
        dbw_render_in_drawer: prop_types_1.bool
    })
};
exports.default = MobileHeader;
//# sourceMappingURL=MobileHeader.js.map